export const styles = {
  container: {
    display: 'flex',
  },
  card: {
    width: '100%',
  },
  text: {
    pl: 1,
    pt: 0.5,
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  buttons: {
    display: 'flex',
    padding: '15px 20px 20px 20px',
  },
  icon: {
    fontSize: 18,
  },
} as const;
